<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Table settings</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md class="pt-0">
          <v-layout wrap>
            <template v-for="(header, headerIndex) of data.headers">
              <v-flex
                :key="headerIndex"
                v-if="header.value !== 'name'"
                xs4
              >
                <v-checkbox
                  v-model="header.active"
                  :label="header.text"
                ></v-checkbox>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
        <v-container fluid grid-list-xl>
          <v-layout wrap align-top justify-end>
            <v-btn color="warning" flat @click="close">
              Close
            </v-btn>
            <v-btn @click="save" color="success">
              Save
            </v-btn>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'dataTableSettingsPopup',
  props: {
    dialog: Boolean,
    headers: Array,
  },
  data() {
    return {
      data: {
        headers: [],
      },
    };
  },
  watch: {
    'headers': {
      immediate: true,
      handler: function() {
        this.setDefHeaders();
      },
    },
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
  },
  methods: {
    setDefHeaders() {
      this.data.headers = JSON.parse(JSON.stringify(this.headers));
    },
    close() {
      this.dialogLocal = false;
      this.setDefHeaders();
    },
    save() {
      this.$emit('update:headers', this.data.headers);
      this.close();
    },
  },
};
</script>
